import React from "react";
import { InvestorPortalHeaderBase } from "../InvestorPortalHeaderBase";
import { ManagerIcon } from "../ManagerIcon/ManagerIcon";
import { WhiteLabelInvestorPortalHeaderProps } from "./WhiteLabelInvestorPortalHeader.types";

export const WhiteLabelInvestorPortalHeader: React.FC<
  WhiteLabelInvestorPortalHeaderProps
> = ({ ...rest }) => {
  return (
    <InvestorPortalHeaderBase {...rest}>
      <ManagerIcon />
    </InvestorPortalHeaderBase>
  );
};
